import apiClient from './client';

export interface DecisionsData {
  criterias: Array<{ id: number; code: string; name: string; desc: string }>;
  rounds: Array<{
    roundNumber: number;
    decisions: Array<{ criteriaId: number; points: number }>;
    total: number;
  }>;
}

export interface ScoresData {
  baseScore: number;
  rounds: Array<{
    roundNumber: number;
    scores: {
      impact1: number;
      impact2: number;
      impact3: number;
      impact4: number | null;
    };
  }>;
  finalScores: {
    impact1: number;
    impact2: number;
    impact3: number;
    impact4: number | null;
  };
}

export interface GraphData {
  labels: string[];
  datasets: Array<{
    label: string;
    data: number[];
    borderColor: string;
    backgroundColor: string;
  }>;
}

export interface GlobalScoresData {
  teamNumber: number;
  finalScores: {
    impact1: number;
    impact2: number;
    impact3: number;
    impact4: number | null;
  };
  graphData: GraphData;
}

export const decisionsApi = {
  async getDecisions(teamNumber: number, sessionCode?: string): Promise<DecisionsData> {
    const response = await apiClient.get(`/game/decisions/${teamNumber}`, {
      params: sessionCode ? { sessionCode } : {},
    });
    return response.data.data;
  },

  async getScores(teamNumber: number, sessionCode?: string): Promise<ScoresData> {
    const response = await apiClient.get(`/game/decisions/${teamNumber}/scores`, {
      params: sessionCode ? { sessionCode } : {},
    });
    return response.data.data;
  },

  async getGlobalScores(sessionCode?: string): Promise<GlobalScoresData[]> {
    const response = await apiClient.get(`/game/decisions/0/scores`, {
      params: sessionCode ? { sessionCode } : {},
    });
    return response.data.data;
  },

  async getGraph(teamNumber: number, sessionCode?: string): Promise<GraphData> {
    const response = await apiClient.get(`/game/decisions/${teamNumber}/graph`, {
      params: sessionCode ? { sessionCode } : {},
    });
    return response.data.data;
  },

  async resetTeam(teamNumber: number, sessionCode?: string): Promise<void> {
    await apiClient.delete(`/game/rounds/team${teamNumber}`, {
      params: sessionCode ? { sessionCode } : {},
    });
  },
};

